// extracted by mini-css-extract-plugin
export default {"to":"SearchResultList_to__hExMu"};